import { SuretyAccountId, SuretyIndemnityAgreementId } from "@inrev/common";
import { useGlobalErrorMessageModal } from "@portal/providers/GlobalErrorHandlingProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { logError } from "../../../utils/error";
import { useRequest } from "../../../utils/request";
import {
	accountIndemnityAgreementsQueryKey,
	accountLatestIndemnityAgreementQueryKey,
	accountQueryKey,
} from "../account.keys";

export const useDeleteIndemnityAgreementFile = (
	accountId: SuretyAccountId,
	indemnityAgreementId: SuretyIndemnityAgreementId,
) => {
	const { _delete } = useRequest();
	const queryClient = useQueryClient();
	const { triggerErrorModal } = useGlobalErrorMessageModal();

	const mutation = useMutation({
		mutationFn: async () => {
			return await _delete(
				`/v2/surety/accounts/${accountId}/indemnity-agreements/${indemnityAgreementId}/file`,
				undefined,
				"none",
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
			queryClient.invalidateQueries({
				queryKey: accountIndemnityAgreementsQueryKey(accountId, indemnityAgreementId),
			});
			queryClient.invalidateQueries({
				queryKey: accountLatestIndemnityAgreementQueryKey(accountId),
			});
		},
		onError: (error: Error) => {
			logError(error);
			triggerErrorModal(error);
		},
	});

	return {
		deleteIndemnityAgreementFile: mutation.mutate,
		deleteIndemnityAgreementFileIsLoading: mutation.isPending,
	};
};
